import { PocketsFilterKeys } from '@epicuro-next/models/pockets';

export const pocketsSearchInputPlaceholder = $localize`:pockets|Placeholder text for thepockets search field@@searchPocketsPlaceholder:Search Pockets`;
export const loadPocketsFailureLabel = $localize`:OrderBook|Orders load failure@@LoadOrdersFailureMessage:Failed to load orders`;

export const pocketsFilterLabelsText = {
  accountIdText: $localize`:pockets|Translation for Account Filter@@pocketsAccountIdFilterName:Account`,
  addressText: $localize`:pockets|Translation for Address@@pocketsAddressFilterName:Address (Ship To)`,
  brandText: $localize`:pockets|Translation for Brand Filter@@pocketsBrandIdFilterName:Brand`,
  categoryText: $localize`:pockets|Translation for Category Filter@@pocketsCategoryFilterName:Category`,
  colorText: $localize`:pockets|Translation for color Filter@@pocketsColorFilterName:Color`,
  deliveryMonthText: $localize`:pockets|Translation for DeliveryDate_requested@@pocketsDeliveryDate_requestedFilterName:Delivery Month`,
  deliveryYearText: $localize`:pockets|Translation for DeliveryDate@@pocketsDeliveryDateFilterName:Delivery Year`,
  divisionText: $localize`:pockets|Translation for Division Filter@@pocketsDivisionFilterName:Division`,
  genderText: $localize`:pockets|Translation for gender Filter@@pocketsGenderFilterName:Gender`,
  masterCategoryText: $localize`:pockets|Translation for Master Category Filter@@pocketsMasterCategoryFilterName:Category`,
  materialGroupText: $localize`:pockets|Translation for Material Group Filter@@pocketsMaterialGroupFilterName:Category`,
  noosText: $localize`:pockets|Translation for Noos Filter@@pocketsNoosFilterName:NOOS`,
  orderStatusText: $localize`:pockets|Translation for Incoming@@pocketsIncomingFilterName:Order Status`,
  orderTypeText: $localize`:pockets|Translation for OrderType@@pocketsOrderTypeFilterName:Order Type`,
  placedPeriodText: $localize`:pockets|Translation for Date_order@@pocketsDate_orderFilterName:Placed Period`,
  subBrandText: $localize`:pockets|Translation for Sub Brand Filter@@pocketsSubBrandIdFilterName:Sub Brand`,
};

export const pocketsFilterLabels: { [key in PocketsFilterKeys]?: string } = {
  [PocketsFilterKeys.Accounts]: pocketsFilterLabelsText.accountIdText,
  [PocketsFilterKeys.Addresses]: pocketsFilterLabelsText.addressText,
  [PocketsFilterKeys.Brands]: pocketsFilterLabelsText.brandText,
  [PocketsFilterKeys.Category]: pocketsFilterLabelsText.categoryText,
  [PocketsFilterKeys.Color]: pocketsFilterLabelsText.colorText,
  [PocketsFilterKeys.Division]: pocketsFilterLabelsText.divisionText,
  [PocketsFilterKeys.MasterCategory]:
    pocketsFilterLabelsText.masterCategoryText,
  [PocketsFilterKeys.Gender]: pocketsFilterLabelsText.genderText,
  [PocketsFilterKeys.Delivered]: pocketsFilterLabelsText.orderStatusText,
  [PocketsFilterKeys.Noos]: pocketsFilterLabelsText.noosText,
  [PocketsFilterKeys.OrderType]: pocketsFilterLabelsText.orderTypeText,
  [PocketsFilterKeys.ProductType]: pocketsFilterLabelsText.materialGroupText,
  [PocketsFilterKeys.SubBrands]: pocketsFilterLabelsText.subBrandText,
};
